module.exports = require('./dist/changesets')



//////////////////
// WEBPACK FOOTER
// ./~/diff-json/index.js
// module id = 384
// module chunks = 0